import { z } from "zod";

export const FaqSchema = z.object({
    id: z.number(),
    question: z.string(),
    answer: z.string(),
});